export default "__VITE_ASSET__CjbGV0a3__"